export default __webpack_public_path__ + "static/media/Ballroll_00229.89f28d8f.png";